import SettingModal from './link-auto-table-setting-modal'

class AutoTableSetting {
	Vue;
	_instance;
	$userConfig;

	constructor(Vue, $userConfig) {
		this.Vue = Vue
		this.$userConfig = $userConfig
	}

	get instance() {
		if (!this._instance) {
			this._instance = this.newInstance()
		}
		return this._instance
	}

	newInstance() {
		const instance = new this.Vue(SettingModal).$mount()
		document.body.appendChild(instance.$el)
		return instance
	}

	async pick(autoTable) {
		return await this.instance.pick(autoTable)
	}

	async saveTableConfig(tableConfig) {
		try {
			const {result} = await this.Vue.prototype.$http.post('action/userConfig/saveTableConfig', {
				...tableConfig,
				linkRequestId: null,
			})
			this.$userConfig.userConfig.tableConfigs[tableConfig.id] = result
			this.$userConfig.saveUserConfig()
		} catch (e) {
			throw e
		}
	}

	async deleteTableConfig(tableConfig) {
		return this.$userConfig.deleteUserConfig(tableConfig)
	}

	getTableConfig(autoOptionOrId, cols) {
		if (this.Vue.prototype.$lv.$utils.typeOf(autoOptionOrId) === 'string') {
			return this.$userConfig.getUserConfig().tableConfigs[autoOptionOrId]
		}
		const newConfig = this.newTableConfig(autoOptionOrId, cols)
		return this.$userConfig.getUserConfig().tableConfigs[newConfig.id] || newConfig
	}

	newTableConfig(autoOption, cols) {
		const navigatorPage = autoOption.context.$lv.getPage(autoOption.context)
		const path = !navigatorPage ? '' : navigatorPage.page.path
		const tableId = autoOption.tableId || ''
		cols = cols.reduce((ret, col) => {
			if (col.group) {
				ret.push(...col.children)
			} else {
				ret.push(col)
			}
			return ret
		}, [])
		cols = cols.map(({field, title, order, hide, fixed, width, fit, id, settingProps = {}}) => ({field, title, order, hide, fixed, width: settingProps.width, fit: settingProps.fit, id}))

		if (cols.length === 0) {
			console.log(autoOption, cols)
			console.error('cols is empty!')
			return {}
		}

		const firstCol = cols[0]
		const lastCol = cols[cols.length - 1]
		const id = tableId + path + `&${firstCol.field}&${firstCol.title}&${lastCol.field}&${lastCol.title}`
		return {
			id,
			tableId,
			path,
			title: autoOption.title,
			sortField: autoOption.sortField,
			sortDesc: autoOption.sortDesc,
			searchField: autoOption.searchField,
			columns: cols
		}
	}
}

export default AutoTableSetting
